import { useContext } from "react";
import { CartContext } from "@middleware/contexts";
import { ICartState } from "@middleware/types";

export const useCart = () => useContext<ICartState>(CartContext);
